import {Button, Navbar} from "inferno-bootstrap";
import {T} from "inferno-i18next";
import {Emoji} from "./input/Emoji";
import {Tooltip} from "../../components/Tooltip";
import Video from "inferno-feather/dist/icons/video";
import VolumeOff from "inferno-feather/dist/icons/volume-x";
import VolumeOn from "inferno-feather/dist/icons/volume-2";
import {Configuration} from "../../services/configuration";
import {Component} from "inferno";
import {IChatMessage} from "../../utils/types";
import TranscriptSave from "./transcript/download/TranscriptSave";

export type Props = { onAttach: (action: "video" | "file") => void, onEndChat: () => void, onEmoji: (emoji: string) => void, onToggleNotification: () => void, notificationActive: boolean, active: boolean, inQueue: boolean,  messages: IChatMessage[] };
export type State = { open: boolean };

export class Footer extends Component<Props, State> {

	state: State = {
		open: false,
	};

	render() {
		return (
			<Navbar style={{"min-height": "40px"}} className="navbar-light bg-light justify-content-between icon-outline-primary flex-shrink-0 chat-footer">
				<div className="d-inline">
					{/*<Dropdown className="d-inline" isOpen={this.state.open} toggle={() => this.setState({open: !this.state.open})}>
						<DropdownToggle id="attach-btn" color="link" disabled={!this.props.active}>
							<Tooltip target="attach-btn" content="VCC_XTOL_CHAT_ATTACH_TOOLTIP" placement="top"/>
							<Plus/>
						</DropdownToggle>
						<DropdownMenu>
							{Configuration.useVideo &&
							<DropdownItem disabled={this.props.inQueue} onClick={() => this.props.onAttach("video")}><Video style={{"width": "16px", "margin-right": "8px"}}/>
								<T className="d-inline" i18nKey="VCC_XLST_CHAT_ATTACH_VIDEO">x</T></DropdownItem>}
							<DropdownItem onClick={() => this.props.onAttach("file")}><Paperclip style={{"width": "16px", "margin-right": "8px"}}/>
								<T className="d-inline" i18nKey="VCC_XLST_CHAT_ATTACH_FILE">x</T></DropdownItem>
						</DropdownMenu>
					</Dropdown>*/}
					{Configuration.useVideo && (
						<Button disabled={this.props.inQueue || !this.props.active} id="video-btn" color="link" style={{"text-decoration": "none"}} onClick={() => this.props.onAttach("video")}>
							<Tooltip target="video-btn" content="VCC_XLST_CHAT_ATTACH_VIDEO" placement="top"/>
							<Video style={{"width": "16px", "margin-right": "8px"}}/>
						</Button>
					)}
					{Configuration.soundNotification && (
						<Button disabled={this.props.inQueue || !this.props.active} color="link" style={{"text-decoration": "none"}} onClick={() => this.props.onToggleNotification()}>
							<VolumeOn id="soff-btn" className={"text-primary" + (!this.props.notificationActive ? "" : " d-none")}/>
							<Tooltip target="soff-btn" content="VCC_XTOL_CHAT_AUDIO_E_TOOLTIP" placement="top"/>
							<VolumeOff id="son-btn" className={"text-primary" + (this.props.notificationActive ? "" : " d-none")}/>
							<Tooltip target="son-btn" content="VCC_XTOL_CHAT_AUDIO_D_TOOLTIP" placement="top"/>
						</Button>
					)}
					<Emoji active={this.props.active} onSelect={this.props.onEmoji}/>
				</div>
				<div className="d-inline">
					{!this.props.active && Configuration.saveTranscript && this.props.messages.length>0 ?
					<TranscriptSave messages={this.props.messages}/>
					:
					<Button outline color="danger" className="btn-sm end-button" disabled={!this.props.active} onClick={this.props.onEndChat}>
						<T i18nKey="VCC_XBUT_CHAT_BUTTON_END">X</T>
					</Button>
					}
				</div>
			</Navbar>
		);
	}
}